import * as React from "react";
import { General } from "./general";
import { Name } from "./name";
import { Ports } from "./ports";
import { WorkloadSubdomain } from "./workloadSubdomain";
import { GvcSubdomain } from "./gvcSubdomain";
import { PortsDedicatedLBCheck } from "./ports_dlb_check";
import { PathBasedGvc } from "./pathBasedGvc";
import { DnsConfig } from "../dnsConfig";
import { DnsConfigAdvanced } from "../dnsConfigAdvanced";
import { ApexConfig } from "../apexConfig";
import { useCpFormContext } from "../../../../components/form/useCpFormContext";
import { formSetValue, useCpFormValue } from "../../../gvc/testNewForm/utils";
import { request } from "../../../../services/cpln";
import { CpTagsNew } from "../../../../components/form/CpTagsNew";

interface Props {}
export const Advanced: React.FC<Props> = () => {
  const { id } = useCpFormContext();
  const gvcLink = useCpFormValue("gvc.link");

  // Fetch GVC item to get alias for DNS config display
  React.useEffect(() => {
    if (gvcLink) {
      request({ url: gvcLink })
        .then(({ data }) => {
          formSetValue(id, "gvc.item", data);
        })
        .catch(() => {
          // Ignore errors - alias display is optional
        });
    }
  }, [gvcLink, id]);

  return (
    <div className="cpln-cards-container flex flex-col gap-4 relative">
      <Name />
      <ApexConfig />
      <General />
      <GvcSubdomain key={"gvcSubdomain"} />
      <WorkloadSubdomain key={"workloadSubdomain"} />
      <PathBasedGvc key={"pathBased"} />
      <PortsDedicatedLBCheck />
      <Ports />
      <DnsConfigAdvanced>
        <DnsConfig />
      </DnsConfigAdvanced>
      <CpTagsNew />
    </div>
  );
};
